import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// Id class
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.franchisee.view.TermsConditionsListTable.';

  public static readonly termsConditions = `${Id.prefix}termsConditions`;
  public static readonly supplier = `${Id.prefix}supplier`;
  public static readonly isDefault = `${Id.prefix}isDefault`;
}

// LangTermsConditionsListTable class
export class LangTermsConditionsListTable {
  private constructor() {}

  public static termsConditions(): string {
    return interpolate(Id.termsConditions);
  }
  public static supplier(): string {
    return interpolate(Id.supplier);
  }
  public static isDefault(): string {
    return interpolate(Id.isDefault);
  }
}

// TermsConditionsListTableModule class
export class TermsConditionsListTableModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.termsConditions, 'Name', 'Column header for terms and conditions name');
    register.add(Id.supplier, "{{glossary 'supplier'}}", 'Column header for supplier');
    register.add(Id.isDefault, 'Default', 'Column header for Default indicator');
  }
}
